<template>
    <div>
        <div style="margin-top: 10px;">
            <p><h5>{{ $t('objects.details.service-orders') }}</h5></p>
        </div>
        <div>
            <p>{{ $t('objects.details.service-orders-desc') }}</p>
        </div>
        <div>
            <service-grid
                :mode="'onlyView'"
                :bus="bus"
                :ordertype="'byRentalObject'"
                :rmsobjectid="rmsobjectid"
            ></service-grid>
        </div>
    </div>
</template>

<script>
    import RmsObjectsHistoryGrid from "./rms-objects-history-grid.vue";

    const lazyServiceGrid = () => import('./rms-objects-service-grid.vue');
    Vue.component('service-grid', lazyServiceGrid);

    export default {
        name: "rms-objects-service-tab",
        props: ['user', 'rmsobjectid'],
        mounted() {
            this.init();
        },
        methods: {
            init: function(){}
        },
        data: function () {
            return {
                bus: new Vue(),
            }
        }
    }
</script>

<style scoped>

</style>
